export const MOBILE_BANNER_IMAGE_SIZE = 175;
export const TABLET_BANNER_IMAGE_SIZE = 240;
export const DESKTOP_BANNER_IMAGE_SIZE = 260;
export const XLARGE_BANNER_IMAGE_SIZE = 437;
export const XXLARGE_BANNER_IMAGE_SIZE = 576;

export const LEFT_BANNER_IMAGES: string[] = [
  "https://cdn.faire.com/fastly/622bd835ffa0866037ae9c7cc6aa353785601e2e7016a2cbe067ff5d53611f86.png",
  "https://cdn.faire.com/fastly/9868a7c69ce4a1399afcb00b5579a18ededa962bba8f6267a47a970422b7a440.png",
  "https://cdn.faire.com/fastly/9868a7c69ce4a1399afcb00b5579a18ededa962bba8f6267a47a970422b7a440.png",
  "https://cdn.faire.com/fastly/227860bfcd9bfd8397688d01399475cedd884a85467773e88d9a6f85a57ec2a9.png",
  "https://cdn.faire.com/fastly/227860bfcd9bfd8397688d01399475cedd884a85467773e88d9a6f85a57ec2a9.png",
  "https://cdn.faire.com/fastly/622bd835ffa0866037ae9c7cc6aa353785601e2e7016a2cbe067ff5d53611f86.png",
];

export const RIGHT_BANNER_IMAGES: string[] = [
  "https://cdn.faire.com/fastly/1b19b472803e8e8d5a16e96ca0c39dc4425f13dbf337a764cb600d7e1dafefb9.png",
  "https://cdn.faire.com/fastly/1b19b472803e8e8d5a16e96ca0c39dc4425f13dbf337a764cb600d7e1dafefb9.png",
  "https://cdn.faire.com/fastly/f00c4cc6f8ab8fb29afa296b28874b5e5f1bff0eeb10ed252c369180f9d41211.png",
  "https://cdn.faire.com/fastly/f00c4cc6f8ab8fb29afa296b28874b5e5f1bff0eeb10ed252c369180f9d41211.png",
  "https://cdn.faire.com/fastly/45424564b9a9bc8c19c405b7fa0460791b686cf154d21a2f183ac4b4aec0df5f.png",
  "https://cdn.faire.com/fastly/45424564b9a9bc8c19c405b7fa0460791b686cf154d21a2f183ac4b4aec0df5f.png",
];

export const IMAGE_WRAPPER_CLASSNAME =
  "relative size-[175px] md:size-[240px] lg:size-[260px] xl:size-[437px] 2xl:size-[576px]";
